/* eslint-disable */
import React, { useEffect, useState } from "react";
import ResponsiveEmbed from "react-responsive-embed";

import Modal from "./Modal";

export default (props) => {
  const { source, id, children, wrapper } = props;
  const [isOpen, setOpen] = useState(false);

  const openVideo = (e) => {
    e.preventDefault();

    setOpen(true);
  };

  const closeVideo = () => {
    setOpen(false);
  };

  useEffect(() => {
    const { current } = wrapper;

    if (current) {
      current.addEventListener("click", openVideo);
    }

    return () => {
      current.removeEventListener("click", openVideo);
    };
  }, [wrapper, isOpen]);

  const src =
    source === "youtube"
      ? `https://www.youtube.com/embed/${id}?autoplay=1`
      : source === "vimeo"
      ? `https://player.vimeo.com/video/${id}?autoplay=1`
      : id;

  return (
    <>
      {children}

      <Modal open={isOpen} closeModal={closeVideo} contentLabel="Video">
        <ResponsiveEmbed src={src} ratio="16:9" allowfullscreen />
      </Modal>
    </>
  );
};
